import React from 'react'
import { StyledSpinner } from './style'

const LoadingSpinner = () => {
	return <StyledSpinner></StyledSpinner>
}

export default LoadingSpinner
